import { render } from "./ServiceCenter.vue?vue&type=template&id=2758cf00&scoped=true"
import script from "./ServiceCenter.vue?vue&type=script&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&lang=js"

import "./ServiceCenter.vue?vue&type=style&index=0&id=2758cf00&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2758cf00"]])

export default __exports__